import { useQuery } from 'react-query';
import axios from 'axios';

const DEFAULT_BRAND_SLUG = 'sivad-ade';

const normalizeBrandSlug = (value) => {
  const raw = String(value || '').trim();
  if (!raw) return DEFAULT_BRAND_SLUG;
  return raw
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '') || DEFAULT_BRAND_SLUG;
};

export const useDropRunState = (campaignId, brandSlug = DEFAULT_BRAND_SLUG, options = {}) => {
  const safeCampaignId = String(campaignId || '').trim();
  const safeBrandSlug = normalizeBrandSlug(brandSlug);

  return useQuery(
    ['drop-run-state', safeCampaignId, safeBrandSlug],
    async () => {
      const response = await axios.get(
        `/api/storefront/${encodeURIComponent(safeBrandSlug)}/drops/${encodeURIComponent(safeCampaignId)}/state`
      );
      return response.data;
    },
    {
      enabled: Boolean(safeCampaignId) && (options.enabled ?? true),
      refetchInterval: 3000,
      retry: 2,
      staleTime: 1000,
    }
  );
};
